export default __webpack_public_path__ + "static/outreach-services-implementation-e5a0aa44342ea56c723d143189c0db5d.jpg";